exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span.ant-calendar-picker .ant-calendar-picker-clear {\n  right: 15px; }\n\nspan.ant-calendar-picker .ant-calendar-picker-icon {\n  right: 33px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/form/DatePicker/style.scss
// module id = 1046
// module chunks = 0